import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      getterContent : 'plataforma/newContent/getterContent',
      getterCourse  : 'plataforma/newContent/getterCourse'
    }),
    context() {
      return this.$route.params.id ? this.getterContent.context : this.getterCourse.context;
    },
    contentId() {
      return this.context.contentId;
    },
    academicMainId() {
      return this.context.academicMainId;
    },
    academicMainTypeId() {
      return this.context.academicMainTypeId;
    },
    enrollmentId() {
      return this.context.enrollmentId;
    }
  }
};
